module.exports = __webpack_public_path__ + "img/ShipBlu Logo Large.f114cac5.png";